import { withTranslation } from "react-i18next";
import React from "react";
import makeStyles from "styles/muiStylesCompat/makeStyles";
import { useTheme } from "@mui/material/styles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import BoxInfo from "./BoxInfo";
import styles from "./styles.css";

const useStyles = makeStyles(styles);

const BoxInfoWithStyles = (props) => {
  const classes = useStyles();
  const theme = useTheme();

  return React.createElement(BoxInfo, { ...props, classes, theme });
};

const mapStateToProps = (_state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(BoxInfoWithStyles),
);
